var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.direction,attrs:{"src":require("../assets/img/arrow-down.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }